import * as React from 'react';
import { compose, withState, withHandlers, withProps } from 'recompose';

import HelpTooltip from '@components/HelpTooltip/HelpTooltip';
import ExportButton from '@components/exportButton/ExportButton';
import { ModalButton } from '@components/modalButton/ModalButton';
import { withNotifications } from '@components/hoc/withNotifications';
import { EventsFormFilesRecordModal } from '@modules/events/EventsFormFilesRecordModal';
import { getRecordId, getAudioRecords, saveAudioRecord } from '@modules/events/_eventsActions';
import { getConfigurationContext } from '@components/provider/configuration/ConfigurationProvider';
import { EventsAudioRecordModal } from '@modules/events/EventsAudioRecordModal';
import { hasAnyPermission } from '@utils/utils';
import { Loader } from '@components/loader';
import { EventsFormFilesMultipleUploader } from './EventsFormFilesMultipleUploader';

const enhance = compose<any, any>(
  withNotifications({ getAudioRecords, saveAudioRecord }),
  withState('loader', 'setLoader', false),
  withState('recordId', 'setRecordId', null),
  withHandlers({
    handleRecordId:
      ({ setRecordId, eventId }) =>
      async () => {
        const response = await getRecordId(eventId);
        setRecordId(response);
      },
    reloadEvent:
      ({ reloadEvent, setLoader }) =>
      async () => {
        setLoader(true);
        await reloadEvent();
        setLoader(false);
      }
  }),
  withProps({
    pbxPermission: hasAnyPermission(['ROLE_BCCP_READ'])
  })
);

const View = ({
  eventId,
  reloadEvent,
  disabled,
  handleRecordId,
  recordId,
  locked,
  getAudioRecordsNotify,
  saveAudioRecordNotify,
  pbxPermission,
  loader,
  afterSubmit,
  setDisableSps
}) => {
  const {
    config: {
      extensions: { sps, pbx }
    }
  } = getConfigurationContext();
  const showAudioReportsButton = !!pbx && pbxPermission;
  return (
    <React.Fragment>
      {loader && <Loader />}
      <ModalButton
        label={'Přidat hromadně'}
        disabled={locked}
        ModalComponent={withProps({ setDisableSps })(EventsFormFilesMultipleUploader)}
        style={{ margin: '0 10px' }}
      />
      <ExportButton
        location="eventDetail"
        formName="form.module-events"
        urlPrefix="/metropolis"
        exportLabel="Export"
        useFileNameDialog={true}
        afterSubmit={afterSubmit}
        eventId={eventId}
        disabled={!eventId}
        style={{ margin: '0 10px' }}
      />
      {!sps && (
        <ModalButton
          label={'Synchronizovat dokumenty'}
          style={{ margin: '0 10px' }}
          disabled={disabled}
          onClick={handleRecordId}
          ModalComponent={EventsFormFilesRecordModal}
          eventId={eventId}
          reloadEvent={reloadEvent}
          alreadyExist={!!recordId}
          sps={sps}
        />
      )}
      {showAudioReportsButton && (
        <ModalButton
          label={'Audio Záznamy'}
          disabled={disabled}
          ModalComponent={EventsAudioRecordModal}
          getAudioRecordsNotify={getAudioRecordsNotify}
          saveAudioRecordNotify={saveAudioRecordNotify}
          pbx={pbx}
          dialogStyles={{
            style: { paddingTop: '5vh' },
            contentStyle: {
              paddingTop: 10,
              transform: 'none'
            },
            bodyStyle: { padding: '0', overflow: 'auto' }
          }}
          eventId={eventId}
          onCloseItem={reloadEvent}
        />
      )}
      {disabled && !locked && (
        <div style={{ height: 36, display: 'flex', alignItems: 'center' }}>
          <HelpTooltip help="Před synchronizací je potřeba uložit změny" tooltipPosition="bottom-left" />
        </div>
      )}
    </React.Fragment>
  );
};

export const ActionBar = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormFilesActionBar.tsx